import { HomeIcon, SubcriptionsFontIcon, BillsFontIcon, EmailIcon, ContactFontIcon } from '../components/CustomIcons'
import { paths } from './router.config';

export const menu_config = [
    { title: 'menu_home', icon: <HomeIcon />, route: paths.home, id: 'menu_home', showMenu: true},
    { title: 'menu_subcriptions', icon: <SubcriptionsFontIcon />, route: paths.subcriptions, id: 'menu_subcriptions', showMenu: true },
    { title: 'invoice_title', icon: <BillsFontIcon />, route: paths.invoices, id: 'menu_invoices', showMenu: true },
    { title: 'menu_support', icon: <EmailIcon/>, route: paths.support, id: 'menu_support', showMenu: true },
    { title: 'menu_profile', icon: <ContactFontIcon style={{with: 24, height: 24}}/>, route: paths.setting, id: 'menu_setting', showMenu: true },
]